export { COLORS, FONTS, SPRING } from "../EAKCArchitecture/constants";

export const SAFE = {
  top: 60,
  bottom: 80,
  left: 120,
  right: 120,
} as const;

export const SCENE = {
  hook:       { start: 0,    duration: 450 },
  problem:    { start: 450,  duration: 900 },
  meetEAKC:   { start: 1350, duration: 900 },
  sources:    { start: 2250, duration: 900 },
  askAnything:{ start: 3150, duration: 900 },
  modes:      { start: 4050, duration: 1350 },
  citations:  { start: 5400, duration: 900 },
  graph:      { start: 6300, duration: 750 },
  admin:      { start: 7050, duration: 750 },
  stats:      { start: 7800, duration: 750 },
  security:   { start: 8550, duration: 600 },
  cta:        { start: 9150, duration: 750 },
} as const;

export const TOTAL_DURATION = 9900;
export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

export const KIKI = {
  sizeSmall: 80,
  sizeLarge: 200,
  cornerPos: { x: 1780, y: 920 },
} as const;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
